import { useState } from 'react';
import '../styles/UserSignupsMetrics.css';
import MetricsChart from '../MetricsChart';

const tabs = [
	'User Signups',
	'Credit Disbursement',
	'Repayment History',
] as const;
type TabKey = (typeof tabs)[number];

const chartDataMap: Record<
	string,
	{ month: string; value: number; shortMonth: string }[]
> = {
	'User Signups': [
		{ month: 'Jan', value: 220, shortMonth: 'Jan.' },
		{ month: 'Feb', value: 65, shortMonth: 'Feb.' },
		{ month: 'Mar', value: 85, shortMonth: 'Mar.' },
		{ month: 'Apr', value: 45, shortMonth: 'Apr.' },
		{ month: 'May', value: 300, shortMonth: 'May' },
		{ month: 'Jun', value: 194, shortMonth: 'Jun.' },
		{ month: 'Jul', value: 175, shortMonth: 'Jul.' },
		{ month: 'Aug', value: 150, shortMonth: 'Aug.' },
		{ month: 'Sep', value: 250, shortMonth: 'Sep.' },
		{ month: 'Oct', value: 35, shortMonth: 'Oct.' },
		{ month: 'Nov', value: 25, shortMonth: 'Nov.' },
		{ month: 'Dec', value: 45, shortMonth: 'Dec.' },
	],
	'Credit Disbursement': [
		{ month: 'Jan', value: 100, shortMonth: 'Jan.' },
		{ month: 'Feb', value: 200, shortMonth: 'Feb.' },
		{ month: 'Mar', value: 140, shortMonth: 'Mar.' },
		{ month: 'Apr', value: 300, shortMonth: 'Apr.' },
		{ month: 'May', value: 250, shortMonth: 'May' },
		{ month: 'Jun', value: 310, shortMonth: 'Jun.' },
		{ month: 'Jul', value: 260, shortMonth: 'Jul.' },
		{ month: 'Aug', value: 280, shortMonth: 'Aug.' },
		{ month: 'Sep', value: 220, shortMonth: 'Sep.' },
		{ month: 'Oct', value: 240, shortMonth: 'Oct.' },
		{ month: 'Nov', value: 260, shortMonth: 'Nov.' },
		{ month: 'Dec', value: 300, shortMonth: 'Dec.' },
	],
	'Repayment History': [
		{ month: 'Jan', value: 50, shortMonth: 'Jan.' },
		{ month: 'Feb', value: 60, shortMonth: 'Feb.' },
		{ month: 'Mar', value: 70, shortMonth: 'Mar.' },
		{ month: 'Apr', value: 80, shortMonth: 'Apr.' },
		{ month: 'May', value: 100, shortMonth: 'May' },
		{ month: 'Jun', value: 90, shortMonth: 'Jun.' },
		{ month: 'Jul', value: 95, shortMonth: 'Jul.' },
		{ month: 'Aug', value: 85, shortMonth: 'Aug.' },
		{ month: 'Sep', value: 75, shortMonth: 'Sep.' },
		{ month: 'Oct', value: 65, shortMonth: 'Oct.' },
		{ month: 'Nov', value: 55, shortMonth: 'Nov.' },
		{ month: 'Dec', value: 45, shortMonth: 'Dec.' },
	],
};


const UserSignupsMetrics = () => {
	const [activeTab, setActiveTab] = useState<TabKey>('User Signups');

	return (
		<div className="metrics-wrapper">
			<div className="fisrt-box">
				<div className="metrics-header">
					<div className="metrics-tabs">
						{tabs.map((tab) => (
							<button
								key={tab}
								className={`tab-button ${activeTab === tab ? 'active' : ''}`}
								onClick={() => setActiveTab(tab)}
							>
								{tab}
							</button>
						))}
					</div>
				</div>

				<h2 className="metrics-section-title">{activeTab}</h2>

				<div className="metrics-content">
					<div className="metrics-placeholder-list">
						<div className="placeholder-box" />
						<div className="placeholder-box" />
						<div className="placeholder-box" />
					</div>

					<div className="metrics-empty-state">
						<h3>No Metrics for {activeTab} at the moment</h3>
						<p>
							To fully unlock the potential of the Raven Atlas, please complete
							your KYC.
						</p>
					</div>
					{/* <MetricsChart data={chartDataMap[activeTab]} /> */}
				</div>
			</div>

			<div className="second-box">
				<h2 style={{ marginBottom: '6rem' }} className="metrics-section-title">
					Recent Repayments
				</h2>

				<div
					className="metrics-content"
					style={{ display: 'flex', flexDirection: 'column' }}
				>
					<div className="metrics-placeholder-list">
						<div className="placeholder-box" />
						<div className="placeholder-box" />
						<div className="placeholder-box" />
					</div>

					<div className="metrics-empty-state">
						<h3
							style={{
								fontSize: '1.8rem',
								fontWeight: 500,
								textAlign: 'center',
							}}
						>
							No Recent repayments yet
						</h3>
						<p
							style={{
								fontSize: '1.6rem',
								fontWeight: 400,
								textAlign: 'center',
								color: 'rgba(103, 103, 103, 1)',
							}}
						>
							Repayments made from credit disbursed show up here
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserSignupsMetrics;
